import { ErrorBoundary } from "next/dist/client/components/error-boundary";
import { ErrorFallback } from "./ErrorFallback";
import React from "react";

type CustomErrorBoundaryProps = {
  children: React.ReactNode;
};

export function CustomErrorBoundary({
  children,
}: CustomErrorBoundaryProps) {
  return (
    <ErrorBoundary errorComponent={ErrorFallback}>{children}</ErrorBoundary>
  );
}
